import React, { useEffect, useState, useRef } from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Timeline } from './components/Timeline';
import { TrustBadges } from './components/TrustBadges';
import { Footer } from './components/Footer';
import { Founder } from './components/Founder';
import { DealHelp } from './components/DealHelp';
import { FAQ } from './components/FAQ';
import { BlogPreview } from './components/BlogPreview';
export const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const sectionsRef = useRef<{
    [key: string]: HTMLDivElement | null;
  }>({});
  useEffect(() => {
    // Comprehensive scroll reset for mobile and desktop
    const resetScroll = () => {
      // Multiple methods to ensure scroll reset
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Disable scroll restoration
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      // Remove URL hash if present
      if (window.location.hash) {
        window.history.replaceState(null, null, window.location.pathname);
      }
      // Remove focus from any elements
      if (document.activeElement && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    };
    // Reset immediately
    resetScroll();
    // Reset again after slight delay for mobile browsers
    setTimeout(resetScroll, 100);
    // Additional mobile-specific reset
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      }, 50);
    }
    // Reset on orientation change (mobile)
    const handleOrientationChange = () => {
      setTimeout(resetScroll, 300);
    };
    window.addEventListener('orientationchange', handleOrientationChange);
    setIsLoaded(true);
    // Intersection Observer for sections
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);
    // Observe all sections
    Object.values(sectionsRef.current).forEach(section => {
      if (section) observer.observe(section);
    });
    return () => {
      Object.values(sectionsRef.current).forEach(section => {
        if (section) observer.unobserve(section);
      });
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#f2efeb] text-[#2b2826] font-sans overflow-x-hidden selection:bg-[#c9a875]/30 selection:text-[#2b2826]" data-id="element-0">
      <Hero data-id="element-1" />
      <Services data-id="element-2" />
      <Timeline data-id="element-3" />
      <DealHelp data-id="element-4" />
      <Founder data-id="element-5" />
      <FAQ data-id="element-6" />
      <BlogPreview data-id="element-7" />
      <TrustBadges showContactForm={true} data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
};